import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import UserForm from "../components/UserForm";
import "../styles/UserForm.css";
import { validateEmail, validatePassword } from "../utils/validators";


const Login = ({ setIsLoggedIn, setUser }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [designation, setDesignation] = useState("");
  const [userLocation, setUserLocation] = useState("");
  const [selectedUserType, setSelectedUserType] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({
    username: "",
    password: "",
  });
  const hasErrors = Object.values(errors).some(Boolean);

  const handleUsernameChange = (e) => {
    const value = e.target.value;
      setUsername(value);
      setErrors((prev) => ({
        ...prev,
        username: validateEmail(value),
      }));
};

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setErrors((prev) => ({
      ...prev,
      password: validatePassword(value),
    }));
  };

  useEffect(() => {
    // Clear global error ONLY when form becomes valid
    if (
      username &&
      password &&
      !hasErrors &&
      errorMessage === "Please fill in all fields"
    ) {
      setErrorMessage("");
    }
  }, [username, password, hasErrors, errorMessage]);

  const handleLogin = async () => {
    setErrorMessage("");

    if (!username || !password){
      setErrorMessage("Please fill in all fields")

      // Clear error message after 5 seconds
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);

      return;
    }

    // BLOCK LOGIN if any errors exist
    if (hasErrors) {
      setErrorMessage("Please fix the errors below to continue.");
      // Clear error message after 5 seconds
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return;
    }

    setLoading(true);
    try {
        const response = await axios.post(`/api/login`, {
            username: username,
            password: password
        });

        if (response.status === 200) {
          setLoading(false);
          const auth = {
            user: response.data,
          };

          localStorage.setItem("auth", JSON.stringify(auth));
          localStorage.setItem("lastLoginDate", new Date().toDateString())

          setUser(response.data);
          setIsLoggedIn(true);
          navigate("/dashboard", { replace: true });
        }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          setErrorMessage("Page not found. Check if correct url is called.");
        } else if (error.response.status === 401) {
          setErrorMessage("Invalid username or password.");
        } else {
            setErrorMessage(
              error.response.data?.error?.message ||
              "Something went wrong. Please try again."
            );
          }
      } else {
        setErrorMessage("Unable to connect to the server. Please try again.");
      }
      setLoading(false);
    }
  };

return (
    <div className="page">
      <UserForm
        title="Welcome Back!"
        subtitle="Please login to continue"
        buttonText="Login"
        showCreateUserLink={true}
        username={username}
        setUsername={handleUsernameChange}
        password={password}
        setPassword={handlePasswordChange}
        designation={designation}
        setDesignation={setDesignation}
        userLocation={userLocation}
        setUserLocation={setUserLocation}
        userType={selectedUserType}
        setUserType={setSelectedUserType}
        errors={errors}
        onSubmit={handleLogin}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        showForgotPassword={true}
        loading={loading}
      />
    </div>
  );
};

export default Login;
